import React, { useEffect, useState, useRef } from 'react';
import { bnToBn } from '@polkadot/util';
import { CWidgetDropdown } from '@coreui/react'
import ChartLineSimple from '../charts/ChartLineSimple'

// Constants
const TIMER_UPDATE_INTERVAL_MS = 100;

// Utility function to calculate and format elapsed time
function getDisplayValue(currentTimestamp = 0, blockTimestamp = 0) {
  const timestampValue = (blockTimestamp && blockTimestamp.getTime
    ? blockTimestamp.getTime()
    : bnToBn(blockTimestamp).toNumber()) || 0;
  
  let formattedDisplay = '0.0 s';
  
  if (currentTimestamp && timestampValue) {
    const elapsedTimeInSeconds = Math.max(Math.abs(currentTimestamp - timestampValue), 0) / 1000;
    formattedDisplay = `${elapsedTimeInSeconds.toFixed(1)} s`;
  }
  
  return formattedDisplay;
}

function Elapsed({ value, style }) {
  const [currentTimestamp, setCurrentTimestamp] = useState(Date.now());
  const timerIntervalRef = useRef(null);

  useEffect(() => {
    // Start the timer when component mounts
    const startTimer = () => {
      timerIntervalRef.current = setInterval(() => {
        setCurrentTimestamp(Date.now());
      }, TIMER_UPDATE_INTERVAL_MS);
    };

    // Stop the timer when component unmounts
    const stopTimer = () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    };

    // Initialize timer
    startTimer();

    // Cleanup function to stop timer on unmount
    return stopTimer;
  }, []); // Empty dependency array ensures this runs only on mount/unmount

  return (
    <React.Fragment>
      <CWidgetDropdown
        color="gradient-info"
        header={getDisplayValue(currentTimestamp, value)}
        text="Block Time"
        style={style}
        footerSlot={
          <ChartLineSimple
            pointed
            className="mt-3 mx-3"
            style={{ height: '70px' }}
            dataPoints={[1, 1, 1, 1, 1]}
            pointHoverBackgroundColor="info"
            options={{ elements: { line: { tension: 0.1 } } }}
            label="Transaction"
            labels="months"
          />
        }
      />
    </React.Fragment>
  );
}

export default Elapsed;